import { takeEvery, put, select } from 'redux-saga/effects'

import { tracking as trackingActions } from 'flux/actions'
import { property as propertySelectors } from 'flux/selectors'

export function* onConversion({ payload: { label } }) {
  const propertyGAWId = yield select(propertySelectors.selectPropertyGoogleAdWords)
  const isProfilingConsent = yield select(propertySelectors.selectIsProfilingConsent)

  // if cookies not consent will not send any event
  if (!isProfilingConsent) return

  // https://developers.google.com/adwords-remarketing-tag/
  yield put(trackingActions.gtag('event', 'conversion', {
    send_to: `${propertyGAWId}/${label}`,
  }))
}

export default function* () {
  yield takeEvery(trackingActions.types.GAW_CONVERSION, onConversion)
}
